import React from "react";
import { useTheme } from "react-jss";
import { RendererProps } from "../BaseRenderer";
import useStyle from "./HeatMapRenderer.styles";

interface Props extends RendererProps {
    imageSrc?: string;
    height?: string;
    width?: string;
    onSelect?(event: any): void;
    top?: string;
    left?: string;
    color?: string;
    text?: string;
    variableName?: string;
    areaCode?: string;
}

export default function HeatMapRenderer(props: Props) {
    const theme = useTheme();
    const divRef = React.useRef();
    const { text, onSelect, variableName } = props;
    const classes = useStyle({ theme });
    const { imageSrc, children, height, width } = props;
    return (
        <>
            <div
                id={variableName}
                className={classes.imageArea}
                aria-label={text}
                role="group"
                onKeyDown={(event) => {
                    if (event.target !== divRef.current) return;
                    if (event.key === " ") {
                        event.preventDefault();
                    }
                }}
                onMouseDown={(event) => {
                    onSelect(event);
                    event.preventDefault();
                }}
            >
                <img
                    className={classes.imageAreaImage}
                    src={imageSrc}
                    alt=""
                    style={{ width, height }}
                />
                {children}
            </div>
        </>
    );
}
